import { gql } from '@apollo/client';

export const QUERY_ADMIN_ONBOARDING = gql`
  query AdminOnboarding {
    adminOnboarding {
      data {
        attributes {
          step1 {
            title
            description
            buttonTxt
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
          step2 {
            title
            subTitle
            autumTermTitle
            springTerm
            summerTerm
            btnText
          }
          schoolManagement {
            welcomeTitle
            welcomeDescription
            yourAccessCode
            btnCopyCodeTxt
            shareCodeTitle
            sendEmailSubTitle
            btnShareCodeTxt
            downloadQrCode
            downloadQrCodeDescription
            btnDownloadPdf
            copyPasteTitle
            copyTxtSubTItle
            btnCopyMessagTxt
            template
            toastStaffInvitedTitle
            toastStaffInvitedDescription
            toastStaffImportedTitle
            toastStaffImportedDescription
            toastErrorDownloadingPDFTitle
            toastPDFDownloadedTitle
            toastPDFDownloadedDescription
            tooltipCopiedMessage
            btnInviteStaffTxt
            btnImportStaffWondeTxt
            orText
            invitationUsingFile {
              uploadSpreadsheetBtn
              seePreviewBtn
              warningMsgDialog
              dialogTitle
              uploadFileBtn
              sendInvitationBtn
              closeBtn
              button
            }
            invitationPreview {
              dialogTitle
              closeBtn
              sendInvitationBtn
              userPreviewSurnameLabel
              userPreviewForenameLabel
              userPreviewEmailLabel
              userPreviewNoStaffLabel
            }
            tabs {
              adminManagementTabName
              surveyDashboardTabName
              reportingDashboardTabName
              announcementsTabName
            }
          }
          dashboard {
            title
            allSchools
            header {
              overallMood
              engagementPastWeek
              surveysResponse
              totalUsers
            }
            chartsTitles {
              schoolMood
              mostUsedFeatures
              featureUsage
              dailyUsers
            }
          }
        }
      }
    }
  }
`;
